import React, { useEffect, useState } from "react";

import CoverPage from "../pages/CoverPage/CoverPage";
import PillarsOfLongevityPage from "../pages/PillarsOfLongevityPage/PillarsOfLongevityPage";
import OverviewMetricBarGraphPage from "../pages/OverviewMetricBarGraphPage/OverviewMetricBarGraphPage";
import CoreMetricsPage from "../pages/CoreMetricsPage/CoreMetricsPage";
import WellnessHealthHistoryPage from "../pages/WellnessHealthHistoryPage/WellnessHealthHistoryPage";
import BiologicalAgePage from "../pages/BiologicalAgePageOld/BiologicalAgePage";
import MetricPage from "../pages/MetricPage/MetricPage";
import TrainingProgramTrianglePage from "../pages/TrainingProgramTrianglePage/TrainingProgramTrianglePage";
import TrainingProgramWorkoutPage from "../pages/TrainingProgramWorkoutPage/TrainingProgramWorkoutPage";
import TrainingProgramPage from "../pages/TrainingProgramPage/TrainingProgramPage";
import EnergyConsumptionFuelingPage from "../pages/EnergyConsumptionFuelingPage/EnergyConsumptionFuelingPage";
import TestingSchedulePage from "../pages/TestingSchedulePage/TestingSchedulePage";
import PerformancePredictionPage from "../pages/PerformancePredictionPage/PerformancePredictionPage";
import AuxiliaryTreatmentsPage from "../pages/AuxiliaryTreatmentsPage/AuxiliaryTreatmentsPage";
import WorkoutDescriptionPage from "../pages/WorkoutDescriptionPage/WorkoutDescriptionPage";
import AuxiliaryTreatmentsPageV02 from "../pages/AuxiliaryTreatmentsPage_V02/AuxiliaryTreatmentsPageV02";

import classes from "../pages/BiologicalAgePage/BiologicalAgePage.module.css";
import UserServicesPage from "../pages/UserServicesPage/UserServicesPage";
// @ts-ignore
import { COMPANY_MAIL_WITH_CUSTOM_REPORT } from "../constants";
import RiskMetricPage from "../pages/MetricPage/RiskMetricPage";
import SupplementsSmartFit from "../pages/SupplementsSmartFit/SupplementsSmartFit";
import { SvgConverterType } from "./Report";
import { NewReportData } from "../../new-reports/types/newReportTypes";
import ScaledNewReportPages from "../components/ScaledNewReportPages";

type Props = {
  data: any;
  newData: NewReportData | undefined;
  svgConverter: SvgConverterType;
  reportType: string;
  isCreatingPDF: boolean;
  customerMail: string;
};

const ReportAMR = ({
  data,
  newData,
  svgConverter,
  reportType,
  isCreatingPDF,
  customerMail,
}: Props) => {
  const isEquinoxReport =
    customerMail !== null
      ? COMPANY_MAIL_WITH_CUSTOM_REPORT.includes(customerMail.toLowerCase())
      : false;
  let wellnessHealthHistoryPageHasContext = false;
  for (
    let i = 0;
    i <
    data.PAGES.find((page: any) => page.PAGE_TYPE === "HEALTH_HISTORY").SECTIONS
      .length;
    i++
  ) {
    if (
      data.PAGES.find((page: any) => page.PAGE_TYPE === "HEALTH_HISTORY")
        .SECTIONS[i].TEXT !== null
    ) {
      wellnessHealthHistoryPageHasContext = true;
    }
  }

  // delete when deployed new VO2 max chart
  const biaxialLineChartDataHandler = () => {
    const biaxialLineChartData = {
      gender: data.GENDER,
      lines_men: [
        {
          x: 15,
          area0: [15, 37],
          area1: [37, 42],
          area2: [42, 47],
          area3: [47, 52],
          area4: [52, 65],
        },
        {
          x: 75,
          area0: [15, 21],
          area1: [21, 24],
          area2: [24, 27],
          area3: [27, 30],
          area4: [30, 65],
        },
        { x: data.AGE, lineUser: data.VO2PEAK },
      ],
      lines_women: [
        {
          x: 15,
          area0: [15, 33],
          area1: [33, 38],
          area2: [38, 42],
          area3: [42, 47],
          area4: [47, 65],
        },
        {
          x: 75,
          area0: [15, 17],
          area1: [17, 20],
          area2: [20, 23],
          area3: [23, 25],
          area4: [25, 65],
        },
        { x: data.AGE, lineUser: data.VO2PEAK },
      ],
    };
    return biaxialLineChartData;
  };

  // Flatten METRICS from ORGANS
  const flattenedMetricsArray = Object.values(
    data.PAGES.find((page: any) => page.PAGE_TYPE === "OVERVIEW").ORGANS
  ).flatMap((organ: any) => [...organ.METRICS]);

  return (
    <>
      <CoverPage
        data={data.PAGES.find((page: any) => (page.PAGE_TYPE = "COVER"))}
        trainerName={data.TRAINER}
        trainerMail={data.TRAINER_MAIL}
        reportType={reportType}
        onSvgConverter={svgConverter}
        isRetoReport={data.customType === "reto"}
        isEvityReport={data.customType === "evity"}
        isAlluraReport={data.customType === "allura"}
        isDiPietroHealth={data.customType === "diPietroHealth"}
        isFourthStreetMedical={data.customType === "4thstreetmedical"}
        gender={data.GENDER}
      />
      <PillarsOfLongevityPage
        data={data.PAGES.find((page: any) => page.PAGE_TYPE === "PILLARS")}
        gender={data.GENDER}
        reportType={reportType}
        isRetoReport={data.customType === "reto"}
        isEvityReport={data.customType === "evity"}
        isFourthStreetMedical={data.customType === "4thstreetmedical"}
      />
      <OverviewMetricBarGraphPage
        data={data.PAGES.find((page: any) => page.PAGE_TYPE === "OVERVIEW")}
        onSvgConverter={svgConverter}
        isCreatingPDF={isCreatingPDF}
        reportType={
          reportType === "10" || reportType === "12" || reportType === "14"
            ? "isAMR"
            : reportType === "18"
            ? "isFrank_AMR"
            : reportType === "17"
            ? "isFrank_RMR"
            : "isRMR"
        }
        isEvityReport={data.customType === "evity"}
      />
      {data.PAGES.find((page: any) => page.PAGE_TYPE === "INTRO") && (
        <CoreMetricsPage
          data={data.PAGES.find((page: any) => page.PAGE_TYPE === "INTRO")}
          reportType={reportType}
          isRestoreReport={false}
          isEvityReport={data.customType === "evity"}
        />
      )}
      {wellnessHealthHistoryPageHasContext && (
        <WellnessHealthHistoryPage
          data={data.PAGES.find(
            (page: any) => page.PAGE_TYPE === "HEALTH_HISTORY"
          )}
          isEvityReport={data.customType === "evity"}
        />
      )}
      <BiologicalAgePage
        data={data.PAGES.find(
          (page: any) => page.PAGE_TYPE === "BIOLOGICAL_AGE"
        )}
        onSvgConverter={svgConverter}
        biaxialLineChartData={biaxialLineChartDataHandler()}
        dataNew={
          data.PAGES.find((page: any) => page.PAGE_TYPE === "OVERVIEW").NAVBAR
        }
        showVO2MaxChart={true}
        isEvityReport={data.customType === "evity"}
        isCreatingPDF={isCreatingPDF}
        customShare={data.custom_share}
      />
      {flattenedMetricsArray.length > 0 && (
        <MetricPage
          isAMRReport={
            reportType === "10" || reportType === "12" || reportType === "14"
          }
          data={flattenedMetricsArray}
          navBarData={
            data.PAGES.find((page: any) => page.PAGE_TYPE === "OVERVIEW").NAVBAR
          }
          qrCodeData={
            data.PAGES.find((page: any) => page.PAGE_TYPE === "OVERVIEW").QRCODE
          }
          isRetoReport={data.customType === "reto"}
          isEvityReport={data.customType === "evity"}
          isSyncLifeReport={data.customType === "syncLife"}
          isMasonCollinsReport={data.customType === "masonCollins"}
        />
      )}
      {data.PAGES.find((page: any) => page.PAGE_TYPE === "OVERVIEW")
        .FRANK_METRICS.length > 0 && (
        <MetricPage
          data={
            data.PAGES.find((page: any) => page.PAGE_TYPE === "OVERVIEW")
              .FRANK_METRICS
          }
          navBarData={
            data.PAGES.find((page: any) => page.PAGE_TYPE === "OVERVIEW").NAVBAR
          }
          qrCodeData={
            data.PAGES.find((page: any) => page.PAGE_TYPE === "OVERVIEW").QRCODE
          }
        />
      )}
      {data.PAGES.find((page: any) => page.PAGE_TYPE === "OVERVIEW").ORGANS
        .CELLS.RISK_METRICS.length > 0 && (
        <RiskMetricPage
          data={data.PAGES.find((page: any) => page.PAGE_TYPE === "OVERVIEW")}
          onSvgConverter={svgConverter}
          isRetoReport={data.customType === "reto"}
          isEvityReport={data.customType === "evity"}
          isSyncLifeReport={data.customType === "syncLife"}
          isMasonCollinsReport={data.customType === "masonCollins"}
        />
      )}
      {data.customType === "smartfit" && (
        <SupplementsSmartFit
          amrCategory={
            data.PAGES.find((page: any) => page.PAGE_TYPE === "OVERVIEW").ORGANS
              .AMR.METRICS[0].VALUE
          }
        />
      )}
      {!isEquinoxReport &&
        !(data.customType === "smartfit") &&
        !(data.customType === "milpitas") && (
          <>
            <TrainingProgramTrianglePage
              data={data.PAGES.find(
                (page: any) => page.PAGE_TYPE === "TRAINING_1"
              )}
              onSvgConverter={svgConverter}
              isEvityReport={data.customType === "evity"}
            />
            <TrainingProgramWorkoutPage
              data={data.PAGES.find(
                (page: any) => page.PAGE_TYPE === "TRAINING_2"
              )}
              isEvityReport={data.customType === "evity"}
            />
            <WorkoutDescriptionPage
              data={data.PAGES.find(
                (page: any) => page.PAGE_TYPE === "TRAINING_INFO"
              )}
              isEvityReport={data.customType === "evity"}
            />
          </>
        )}
      <TrainingProgramPage
        data={data.PAGES.find((page: any) => page.PAGE_TYPE === "TRAINING_3")}
        isEvityReport={data.customType === "evity"}
      />

      <EnergyConsumptionFuelingPage
        data={data.PAGES.find(
          (page: any) => page.PAGE_TYPE === "ENERGY_CONSUMPTION"
        )}
        reportType={reportType}
        isEvityReport={data.customType === "evity"}
      />
      <TestingSchedulePage
        data={data.PAGES.find(
          (page: any) => page.PAGE_TYPE === "TESTING_SCHEDULE"
        )}
        onSvgConverter={svgConverter}
        isEvityReport={data.customType === "evity"}
        isFountainLife={data.customType === "fountainLife"}
      />
      {reportType === "14" && (
        <PerformancePredictionPage
          data={data.PAGES.find(
            (page: any) => page.PAGE_TYPE === "PERFORMANCE_PREDICTION"
          )}
          onSvgConverter={svgConverter}
          isEvityReport={data.customType === "evity"}
        />
      )}
      {newData &&
        newData.pages &&
        newData.pages.some(
          (page) => page.pageType === "services" && page.services.length > 0
        ) && <ScaledNewReportPages newData={newData} />}
    </>
  );
};

export default ReportAMR;
